import {useAppSelector} from '../../store/store';
import styles from './notifications.module.scss';
import {NotificationListItem} from '../../components/notification/notification_list_item.tsx';
import {__} from '../../support/lang/translations.ts';
import {NotificationListItemsPlaceholder} from '../../components/notification/notification_list_item_placeholder.tsx';
import {useParams} from 'react-router-dom';
import {NotificationType} from './notification.tsx';
import {brandLogo} from '../../support/brand_logo.ts';

export function NotificationsList() {
    const customerInfo = useAppSelector((state) => state.customerInfo);

    const notificationsData = useAppSelector((state) => state.notifications);

    const unreadNotifications = notificationsData.notifications?.filter((notification) => !notification?.read);
    const readNotifications = notificationsData.notifications?.filter((notification) => notification?.read === true);
    const params = useParams<'notificationId'>();
    const notificationId = parseInt(params.notificationId ?? '-1', 10);

    const unreadVehicleNotifications =
        unreadNotifications?.filter((notification) => notification?.type === NotificationType.Vehicle) ?? [];
    const unreadGeneralNotifications =
        unreadNotifications?.filter((notification) => notification?.type === NotificationType.General) ?? [];

    const vehicleByVehicleId = (vehicleId?: number | null) => {
        return customerInfo.me?.customer?.vehicles?.find((v) => v?.id === vehicleId);
    };

    return (
        <div className={styles.notifications_list}>
            <div className={styles.list_title}>
                <h2>{__('notifications.titles.unread')}</h2>
            </div>
            <div className={styles.list_subtitle}>
                <h3>{__('notifications.titles.vehicles')}</h3>
            </div>
            <div className={styles.list_items}>
                {unreadVehicleNotifications && unreadVehicleNotifications.length > 0 ? (
                    <>
                        {unreadVehicleNotifications.map((notification, index) => {
                            return (
                                <NotificationListItem
                                    key={`${notification?.id}-${index}`}
                                    title={notification?.title ?? ''}
                                    message={notification?.message ?? ''}
                                    date={notification?.created_at_iso8601}
                                    to={`/notifications/${notification?.id}`}
                                    read={notification?.read !== false}
                                    active={notification?.id === notificationId}
                                    iconClass={notification?.type === NotificationType.General ? 'fa-user' : 'fa-car'}
                                    src={brandLogo(vehicleByVehicleId(notification?.vehicle_id)?.brand)}
                                />
                            );
                        })}
                    </>
                ) : (
                    <NotificationListItemsPlaceholder />
                )}
            </div>

            <div className={styles.list_subtitle}>
                <h3>{__('notifications.titles.general')}</h3>
            </div>
            <div className={styles.list_items}>
                {unreadGeneralNotifications && unreadGeneralNotifications.length > 0 ? (
                    <>
                        {unreadGeneralNotifications.map((notification, index) => {
                            return (
                                <NotificationListItem
                                    key={`${notification?.id}-${index}`}
                                    title={notification?.title ?? ''}
                                    message={notification?.message ?? ''}
                                    date={notification?.created_at_iso8601}
                                    to={`/notifications/${notification?.id}`}
                                    read={notification?.read !== false}
                                    active={notification?.id === notificationId}
                                    iconClass={notification?.type === NotificationType.General ? 'fa-user' : 'fa-car'}
                                    src={brandLogo(vehicleByVehicleId(notification?.vehicle_id)?.brand)}
                                />
                            );
                        })}
                    </>
                ) : (
                    <NotificationListItemsPlaceholder />
                )}
            </div>

            <div className={styles.list_title}>
                <h2>{__('notifications.titles.read')}</h2>
            </div>

            {readNotifications && readNotifications.length > 0 ? (
                <>
                    {readNotifications.map((notification, index) => {
                        return (
                            <NotificationListItem
                                key={`${notification?.id}-${index}`}
                                title={notification?.title ?? ''}
                                message={notification?.message ?? ''}
                                date={notification?.created_at_iso8601}
                                to={`/notifications/${notification?.id}`}
                                read={notification?.read !== false}
                                active={notification?.id === notificationId}
                                iconClass={notification?.type === NotificationType.General ? 'fa-user' : 'fa-car'}
                                src={brandLogo(vehicleByVehicleId(notification?.vehicle_id)?.brand)}
                            />
                        );
                    })}
                </>
            ) : (
                <NotificationListItemsPlaceholder />
            )}
        </div>
    );
}
